// Copyright ©️ 2026 eVolve MEP, LLC

import type { GridState } from 'ag-grid-enterprise';

import { doNotSaveColumnIdentifier } from 'helpers/ag-grid/baseColumnDef';
import type { SavedGridState } from 'helpers/ag-grid/TableViewPanel/types';

const removeLockedColIdsFromArray = (arr: string[]) =>
  arr.filter((colId) => !colId.startsWith(doNotSaveColumnIdentifier));

export const getSavedGridState = (gridState: GridState): SavedGridState => {
  const savedGridState: SavedGridState = {
    filter: gridState.filter,
    sort: gridState.sort,
    version: gridState.version,
  };

  // Remove any locked columns from the saved state.
  if (gridState.columnOrder) {
    savedGridState.columnOrder = {
      ...gridState.columnOrder,
      orderedColIds: removeLockedColIdsFromArray(gridState.columnOrder.orderedColIds),
    };
  }
  if (gridState.columnPinning) {
    savedGridState.columnPinning = {
      ...gridState.columnPinning,
      leftColIds: removeLockedColIdsFromArray(gridState.columnPinning.leftColIds),
      rightColIds: removeLockedColIdsFromArray(gridState.columnPinning.rightColIds),
    };
  }
  if (gridState.columnSizing) {
    savedGridState.columnSizing = {
      ...gridState.columnSizing,
      columnSizingModel: gridState.columnSizing.columnSizingModel.filter(
        ({ colId }) => !colId.startsWith(doNotSaveColumnIdentifier),
      ),
    };
  }
  if (gridState.columnVisibility) {
    savedGridState.columnVisibility = {
      ...gridState.columnVisibility,
      hiddenColIds: removeLockedColIdsFromArray(gridState.columnVisibility.hiddenColIds),
    };
  }

  return savedGridState;
};
